import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { delay1diib1rb84y4j as delay } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/Delay.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { CoroutineScopefcb5f5dwqcas as CoroutineScope } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { get_AppScopes4bqeg21n0qw as get_AppScope } from '../../../../reactive/com/lightningkite/reactive/core/AppScope.mjs';
import { launch1c91vkjzdi9sd as launch } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import {
  Duration5ynfiptaqcrg as Duration,
  Duration__hashCode_impl_u4exz629donm5f9ouki as Duration__hashCode_impl_u4exz6,
} from '../../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
import { toString30pk9tzaqopn as toString } from '../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import {
  toString1pkumu07cwy4m as toString_0,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { onRemove3k528udkni1ni as onRemove } from '../../../../reactive/com/lightningkite/reactive/context/CalculationContext.mjs';
import { invokeAllSafeMutable13vuy5ase10ma as invokeAllSafeMutable } from '../../../../reactive/com/lightningkite/reactive/extensions/helpers.mjs';
import {
  beginUse146s8dwmfk72s as beginUse,
  Listenable3m4zqvjcbvczy as Listenable,
} from '../../../../reactive/com/lightningkite/reactive/core/coreInterfaces.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function *_generator_invoke__zhh2q8($this, $this$launch, $completion) {
  var tmp0_safe_receiver = RequestFocus_instance.eg5_1;
  if (tmp0_safe_receiver == null)
    null;
  else {
    tmp0_safe_receiver.cbn(['Delaying scroll']);
  }
  var tmp = delay($this.ig5_1.gg5_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp1_safe_receiver = RequestFocus_instance.eg5_1;
  if (tmp1_safe_receiver == null)
    null;
  else {
    tmp1_safe_receiver.cbn(['focusing']);
  }
  $this.ig5_1.fg5_1.qb9();
  return Unit_instance;
}
var RequestFocus$Target$focus$slambdaClass;
function RequestFocus$Target$focus$slambda() {
  if (RequestFocus$Target$focus$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.ig5_1 = this$0;
      }
      yah($this$launch, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, $this$launch), $completion);
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    RequestFocus$Target$focus$slambdaClass = $;
  }
  return RequestFocus$Target$focus$slambdaClass;
}
function RequestFocus$Target$focus$slambda_0(this$0) {
  var i = new (RequestFocus$Target$focus$slambda())(this$0);
  var l = ($this$launch, $completion) => i.yah($this$launch, $completion);
  l.$arity = 1;
  return l;
}
function RequestFocus$TargetHandler$setTarget$lambda() {
  return Unit_instance;
}
var TargetClass;
function Target() {
  if (TargetClass === VOID) {
    class $ {
      constructor(view, delayBeforeFocus, action) {
        delayBeforeFocus = delayBeforeFocus === VOID ? null : delayBeforeFocus;
        this.fg5_1 = view;
        this.gg5_1 = delayBeforeFocus;
        this.hg5_1 = action;
      }
      rb9() {
        var tmp0_safe_receiver = RequestFocus_instance.eg5_1;
        if (tmp0_safe_receiver == null)
          null;
        else {
          tmp0_safe_receiver.cbn(['going to target']);
        }
        this.hg5_1();
        var tmp = this.gg5_1;
        if (!((tmp == null ? null : new (Duration())(tmp)) == null)) {
          var tmp_0 = get_AppScope();
          launch(tmp_0, VOID, VOID, RequestFocus$Target$focus$slambda_0(this));
        } else {
          var tmp1_safe_receiver = RequestFocus_instance.eg5_1;
          if (tmp1_safe_receiver == null)
            null;
          else {
            tmp1_safe_receiver.cbn(['focusing']);
          }
          this.fg5_1.qb9();
        }
      }
      toString() {
        var tmp = this.fg5_1.toString();
        var tmp_0 = this.gg5_1;
        return 'Target(view=' + tmp + ', delayBeforeFocus=' + toString(tmp_0 == null ? null : new (Duration())(tmp_0)) + ', action=' + toString_0(this.hg5_1) + ')';
      }
      hashCode() {
        var result = hashCode(this.fg5_1);
        var tmp = imul(result, 31);
        var tmp_0;
        var tmp_1 = this.gg5_1;
        if ((tmp_1 == null ? null : new (Duration())(tmp_1)) == null) {
          tmp_0 = 0;
        } else {
          tmp_0 = Duration__hashCode_impl_u4exz6(this.gg5_1);
        }
        result = tmp + tmp_0 | 0;
        result = imul(result, 31) + hashCode(this.hg5_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Target()))
          return false;
        if (!equals(this.fg5_1, other.fg5_1))
          return false;
        var tmp = this.gg5_1;
        var tmp_0 = tmp == null ? null : new (Duration())(tmp);
        var tmp_1 = other.gg5_1;
        if (!equals(tmp_0, tmp_1 == null ? null : new (Duration())(tmp_1)))
          return false;
        if (!equals(this.hg5_1, other.hg5_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Target');
    TargetClass = $;
  }
  return TargetClass;
}
var TargetHandlerClass;
function TargetHandler() {
  if (TargetHandlerClass === VOID) {
    class $ {
      constructor(name) {
        this.jg5_1 = name;
        this.kg5_1 = ArrayList().w();
        this.lg5_1 = null;
        this.mg5_1 = false;
      }
      vah(listener) {
        var tmp0_safe_receiver = RequestFocus_instance.eg5_1;
        if (tmp0_safe_receiver == null)
          null;
        else {
          tmp0_safe_receiver.cbn(['Adding listener for ' + this.jg5_1]);
        }
        this.kg5_1.v(listener);
        if (this.mg5_1) {
          var tmp1_safe_receiver = RequestFocus_instance.eg5_1;
          if (tmp1_safe_receiver == null)
            null;
          else {
            tmp1_safe_receiver.cbn([this.jg5_1 + ' Calling listener immediately']);
          }
          listener();
        }
        return () => {
          var tmp0_safe_receiver = RequestFocus_instance.eg5_1;
          if (tmp0_safe_receiver == null)
            null;
          else {
            tmp0_safe_receiver.cbn(['Removing listener for ' + this.jg5_1]);
          }
          this.kg5_1.w3(listener);
          return Unit_instance;
        };
      }
      og4(view, delayBeforeFocus, onFocus) {
        var tmp0_safe_receiver = RequestFocus_instance.eg5_1;
        if (tmp0_safe_receiver == null)
          null;
        else {
          tmp0_safe_receiver.cbn([this.jg5_1 + ' Adding target']);
        }
        this.lg5_1 = new (Target())(view, delayBeforeFocus, onFocus);
        onRemove(view, () => {
          var tmp;
          var tmp1_safe_receiver = this.lg5_1;
          if (view === (tmp1_safe_receiver == null ? null : tmp1_safe_receiver.fg5_1)) {
            var tmp0_safe_receiver = RequestFocus_instance.eg5_1;
            if (tmp0_safe_receiver == null)
              null;
            else {
              tmp0_safe_receiver.cbn([this.jg5_1 + ' removing target']);
            }
            this.lg5_1 = null;
            tmp = Unit_instance;
          }
          return Unit_instance;
        });
        if (this.mg5_1) {
          var tmp1_safe_receiver = RequestFocus_instance.eg5_1;
          if (tmp1_safe_receiver == null)
            null;
          else {
            tmp1_safe_receiver.cbn([this.jg5_1 + ' Fulfilling awaiting target']);
          }
          var tmp2_safe_receiver = this.lg5_1;
          if (tmp2_safe_receiver == null)
            null;
          else {
            tmp2_safe_receiver.rb9();
          }
          this.mg5_1 = false;
        }
      }
      ng5(view, delayBeforeFocus, onFocus, $super) {
        delayBeforeFocus = delayBeforeFocus === VOID ? null : delayBeforeFocus;
        var tmp;
        if (onFocus === VOID) {
          tmp = RequestFocus$TargetHandler$setTarget$lambda;
        } else {
          tmp = onFocus;
        }
        onFocus = tmp;
        var tmp_0;
        if ($super === VOID) {
          this.og4(view, delayBeforeFocus, onFocus);
          tmp_0 = Unit_instance;
        } else {
          var tmp_1 = $super.og4;
          var tmp_2 = delayBeforeFocus;
          tmp_0 = tmp_1.call(this, view, tmp_2 == null ? null : new (Duration())(tmp_2), onFocus);
        }
        return tmp_0;
      }
      og5() {
        invokeAllSafeMutable(this.kg5_1);
        var tmp0_safe_receiver = this.lg5_1;
        var tmp;
        if (tmp0_safe_receiver == null) {
          tmp = null;
        } else {
          // Inline function 'kotlin.also' call
          var tmp0_safe_receiver_0 = RequestFocus_instance.eg5_1;
          if (tmp0_safe_receiver_0 == null)
            null;
          else {
            tmp0_safe_receiver_0.cbn(['Target found for ' + this.jg5_1]);
          }
          tmp = tmp0_safe_receiver;
        }
        var tmp1_safe_receiver = tmp;
        var tmp_0;
        if (tmp1_safe_receiver == null) {
          tmp_0 = null;
        } else {
          tmp1_safe_receiver.rb9();
          tmp_0 = Unit_instance;
        }
        if (tmp_0 == null) {
          // Inline function 'kotlin.run' call
          var tmp0_safe_receiver_1 = RequestFocus_instance.eg5_1;
          if (tmp0_safe_receiver_1 == null)
            null;
          else {
            tmp0_safe_receiver_1.cbn(['No target found for ' + this.jg5_1]);
          }
          this.mg5_1 = true;
        }
      }
    }
    protoOf($).kaj = beginUse;
    initMetadataForClass($, 'TargetHandler', VOID, VOID, [Listenable()]);
    TargetHandlerClass = $;
  }
  return TargetHandlerClass;
}
var RequestFocusClass;
function RequestFocus() {
  if (RequestFocusClass === VOID) {
    class $ {
      constructor() {
        this.eg5_1 = null;
      }
    }
    initMetadataForObject($, 'RequestFocus');
    RequestFocusClass = $;
  }
  return RequestFocusClass;
}
var RequestFocus_instance;
function RequestFocus_getInstance() {
  return RequestFocus_instance;
}
//region block: init
RequestFocus_instance = new (RequestFocus())();
//endregion
//region block: exports
export {
  TargetHandler as TargetHandler15cm4auxqf0yk,
};
//endregion

//# sourceMappingURL=RequestFocus.mjs.map
